<template>
    <li :class="[hover.link ? 'sfHover' : '', active ? 'active' : '']" 
        @mouseover="dropdownOver" @mouseout="dropdownLeave" 
        ref='dropdown'>
        <slot name="title"></slot>
        <ul v-show="view" style="display: block" 
            @mouseover="dropdownMenuOver" @mouseout="dropdownMenuLeave"
            ref='dropdownMenu'>
            <slot name="options"></slot>
        </ul>
    </li>
</template>

<script>
export default {
    name: 'dropdown-hover',
    props: ['active'],
    data() {
        return {
            view: false,
            hover: {
                link: false,
                menu: false
            }
        }
    },
    methods: {
        dropdownOver() {
            this.hover.link = true
            this.view = true
        },
        dropdownLeave() {
            this.hover.link = false
        },
        dropdownMenuOver() {
            this.hover.menu = true
            this.view = true
        },
        dropdownMenuLeave() {
            this.hover.menu = false
        },
    },
    watch: {
        hover: {
            deep: true,
            handler: function() {
                var _this = this
                setTimeout(function(){
                    if(!_this.hover.menu && !_this.hover.link) _this.view = false
                }, 100)
            }
        }
    }
}
</script>
